import React from 'react';

const PageHeader = ({
  kicker,
  title,
  subtitle,
  actions,
  center = false,
  className = '',
}) => (
  <div className={`page-header ${center ? 'page-header--center' : ''} ${className}`.trim()}>
    {kicker && <span className="t12-badge">{kicker}</span>}
    <div className={`page-header-row ${center ? 'page-header-row--center' : ''}`}>
      <div className={center ? 'text-center' : ''}>
        <h1 className="section-title">{title}</h1>
        {subtitle && <p className="page-subtitle">{subtitle}</p>}
      </div>
      {actions && <div className="page-actions">{actions}</div>}
    </div>
  </div>
);

export default PageHeader;
